module.exports = __webpack_public_path__ + "img/app_brand_bioTrack.b64790c6.svg";